
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getCustomerList } from '@/api/customer';
import { UserModule } from '@/store/modules/user';
import { lAreaData } from '@/const/LAreaData';

@Component({
  name: 'GroupCustomer',
  components: {}
})
export default class extends Vue {
  @Prop({
    type: Array,
    default: () => []
  })
  selcetCustomer!: any;

  private customerSearch: any = {
    name: '',
    address: ''
  };
  private lAreaData!: any;
  private defaultProps: any = {
    children: 'child',
    label: 'name',
    value: 'id'
  };

  private listLoading = false;
  private isPrev = false;

  private checkAllCustomer = false;
  private isIndeterminateCustomer: any = null;
  private customerCheckedSelected: any = [];
  private customerIdCheckedSelected: any = [];
  private customerTableData: any = [];
  private checkAllCustomerChange(val: boolean) {
    this.dealData(val, this.customerIdCheckedSelected, this.customerTableData, 0);
    this.isIndeterminateCustomer = false;
    this.$emit('checkedCustomerChange', this.customerCheckedSelected);
  }
  private checkedCustomerChange(checked: any, val: any) {
    if (checked) {
      this.customerCheckedSelected.push(val);
    } else {
      let indexa = -1;
      for (let index = 0; index < this.customerCheckedSelected.length; index++) {
        const element = this.customerCheckedSelected[index];
        if (parseInt(element.customer_type) === 1) {
          if (element.customer_company_id === val.customer_company_id) {
            indexa = index;
            break;
          }
        } else {
          if (element.customer_user_id === val.customer_user_id) {
            indexa = index;
            break;
          }
        }
      }
      if(indexa>-1){
        this.customerCheckedSelected.splice(indexa, 1);
      }
    }
    let p = [];
    p.push(val);
    this.dealData(checked, this.customerIdCheckedSelected, p, 0);
    this.$emit('checkedCustomerChange', this.customerCheckedSelected);
  }
  // 底下全部选中 上方全选选中
  private handleCheckedSelectedChange(val: any) {
    let checkedCount = val.length;
    let _length = this.getAllLength(0, this.customerTableData, 0);
    this.checkAllCustomer = checkedCount === _length;
    this.isIndeterminateCustomer = checkedCount > 0 && checkedCount < _length;
  }
  // 递归数组 把所有选中的子集设置为选中
  private dealData(check: any, options: any, list: any, n: any) {
    n++;
    if (n > 5) {
      return;
    }
    for (let i = 0; i < list.length; i++) {
      this.pushData(check, options, list[i]);
      if (list[i].child) {
        this.dealData(check, options, list[i].child, n);
      }
    }
  }

  // 计算所有项 长度
  private getAllLength(length: any, list: any, n: any) {
    n++;
    if (n > 5) {
      return;
    }
    if (list && list.length > 0) {
      length += list.length;
      for (let i = 0; i < list.length; i++) {
        length = this.getAllLength(length, list[i].child, n);
      }
    }
    return length;
  }
  // 增加数据
  private pushData(check: any, list: any, val: any) {
    let id = '';
    if (parseInt(val.customer_type) === 1) {
      id = val.customer_company_id;
    } else {
      id = val.customer_user_id;
    }
    let index = list.indexOf(id);
    if (check) {
      if (index === -1) {
        this.customerCheckedSelected.push(val);
        this.customerIdCheckedSelected.push(id);
      }
    } else {
      if (index !== -1) {
        list.splice(index, 1);
        this.customerCheckedSelected.splice(index, 1);
      }
    }
  }

  private dialogResult: any = {};

  created() {
    this.getCustomerList('', '', '');
    this.lAreaData = lAreaData;
    this.lAreaData.map((item: any) => {
      if (item && item.child && item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item &&
          item.child &&
          item.child.map((temp: any) => {
            if (temp && temp.child && temp.child.length === 0) {
              (temp.child as any) = undefined;
            }
          });
      }
    });
  }

  // 搜索
  private searchHandle() {
    this.page = 1;
    this.getCustomerList('', '', '');
  }

  // 清空
  private searchClearHandle() {
    this.customerSearch = {
      name: '',
      address: ''
    };
    this.page = 1;
    this.getCustomerList('', '', '');
  }
  private closeCustomerHandle(item: any, index: number) {
    this.customerCheckedSelected.splice(index, 1);
    // this.customerIdCheckedSelected.splice(index, 1);
    // let removeIndex = this.customerCheckedSelected.findIndex((customerItem:any)=>{
    //   if (parseInt(item.customer_type) === parseInt(customerItem.customer_type)) {
    //     if(parseInt(item.customer_type) == 1){
    //       if(item.customer_company_id === customerItem.customer_company_id){
    //         return true;
    //       }
    //     }else{
    //       if(item.customer_user_id === customerItem.customer_user_id){
    //         return true;
    //       }
    //     }
    //     return false;
    //   }else{
    //     return false;
    //   }
    // })
    // if(removeIndex!==-1){
    //   this.customerCheckedSelected.splice(removeIndex,1);
    // }

    let idRemoveIndex = this.customerIdCheckedSelected.findIndex((customerItemId:any)=>{
      if(parseInt(item.customer_type) == 1){
        return item.customer_company_id === customerItemId
      }else{
        return item.customer_user_id === customerItemId
      }
    })
    if(idRemoveIndex!==-1){
      this.customerIdCheckedSelected.splice(idRemoveIndex,1);
    }
  
    if (this.customerCheckedSelected.length > 0) {
      this.isIndeterminateCustomer = true;
    } else {
      this.checkAllCustomer = false;
      this.isIndeterminateCustomer = false;
    }
    this.$emit('checkedCustomerChange', this.customerCheckedSelected);
  }
  private loadMoreCustomer() {
    this.page = this.page + 1;
    this.getCustomerList('', '', '');
  }

  load(tree:any, treeNode:any, resolve:any) {
    this.getCustomerList(tree.customer_company_id, tree, resolve);
  }

  private page = 1;
  private totalPage = 1;
  private getCustomerList(pid:any, tree:any, resolve:any) {
    this.listLoading = true;
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      page: this.page,
      size: 10,
      is_show_set_push_remark: 1
      // contain_branch: 1
    };
    if (pid) {
      params.customer_company_pid = pid;
      params.size = 999999;
    }
    if (this.customerSearch.name) {
      params.customer_name = this.customerSearch.name;
    }
    if (this.customerSearch.address) {
      params.address = this.customerSearch.address;
    }
    getCustomerList(params)
      .then((res: any) => {
        if (pid) {
          if (res.data && res.data.list) {
            let dataTable:any = res.data.list;
            tree.child = dataTable;
            dataTable.forEach((item:any) => {
              (item as any).hasChildren = parseInt(item.lower_count) > 0;
            });
            resolve(dataTable);
          } else {
            resolve([]);
          }
        } else {
          if (res.data && res.data.list) {
            this.totalPage = res.data.page_count;
            res.data.list.forEach((item:any) => {
              (item as any).hasChildren = parseInt(item.lower_count) > 0;
            });
            if (this.page === 1) {
              this.customerTableData = res.data.list;
            } else {
              this.customerTableData = this.customerTableData.concat(
                res.data.list
              );
            }
            this.setSelect(this.customerTableData);
          } else {
            if (this.page === 1) {
              this.customerTableData = [];
            }
          }
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.customerTableData = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }
  private setSelect(list: any) {
    if (this.selcetCustomer && this.selcetCustomer.length > 0) {
      for (let i = 0; i < this.selcetCustomer.length; i++) {
        let item: any = this.selcetCustomer[i];
        if (parseInt(item.customer_type) === 1) {
          let arr = this.customerIdCheckedSelected.filter((v: any) => {
            return v === item.customer_company_id;
          });
          if (!arr || arr.length < 1) {
            this.customerIdCheckedSelected.push(item.customer_company_id);
            this.customerCheckedSelected.push(item);
          }
        } else {
          let arr = this.customerIdCheckedSelected.filter((v: any) => {
            return v === item.customer_user_id;
          });
          if (!arr || arr.length < 1) {
            this.customerIdCheckedSelected.push(item.customer_user_id);
            this.customerCheckedSelected.push(item);
          }
        }
      }
      if (this.customerCheckedSelected.length === this.customerTableData.length) {
        this.checkAllCustomer = true;
        this.isIndeterminateCustomer = false;
      }
    }
  }
}
